import PageHeaderBlock from '@/registry/evo-shadcn/blocks/page-header';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { BarChart3 } from 'lucide-react';

export function BudgetsPage() {
  return (
    <div className="space-y-6">
      <PageHeaderBlock
        title="Budget Variance"
        subtitle="Track budget vs actuals with variance alerts"
        size={20}
        showActions={false}
      />

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <BarChart3 className="h-5 w-5 text-info-600" />
            Budget Analysis
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            This feature is in preview. Enable Live Mode in Feature Labs to use with your real data.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
